import { Badge, Box, Flex, Text, useColorMode } from '@chakra-ui/react';
import { Link } from '@reach/router';
import moment from 'moment';

import { buildHubCounterStatusBadges } from './Card';
import { HubCounterListItem } from './query';

export const HubCounterTableRow = (props: HubCounterListItem) => {
  const { hubCounter } = props;
  const { dropPoint } = hubCounter;
  const { colorMode } = useColorMode();
  const statusBadges = buildHubCounterStatusBadges(props);

  return (
    <Box
      as={Link}
      to={`/users/${dropPoint.user.id}`}
      gridColumn="span 3"
      width="100%"
      borderWidth="1px"
      borderBottom="0"
      px="4"
      py="2"
      _last={{ borderBottom: '1px solid #E2E8F0' }}
      _hover={{ boxShadow: 'sm', backgroundColor: colorMode === 'light' ? 'white' : 'gray.700' }}
    >
      <Flex flexWrap="wrap" mb="2" gap="2">
        {statusBadges.map((badge) => (
          <Badge key={badge.label} colorScheme={badge.colorScheme}>
            {badge.label}
          </Badge>
        ))}
      </Flex>
      <Text mb="1" fontFamily="heading" fontSize="lg" fontWeight="bold">
        {dropPoint.locationName || `${dropPoint.user.firstName} ${dropPoint.user.lastName}`}
      </Text>
      <Flex>
        {dropPoint.address ? (
          <Box flex="1">
            <Text mb="2">
              {dropPoint.address.street} {dropPoint.address.houseNumber}
              <br />
              {dropPoint.address.postalCode} {dropPoint.address.city}
            </Text>
          </Box>
        ) : null}
        <Box flex="1">
          {hubCounter.hubCounterID ? (
            <Text color={colorMode === 'light' ? 'gray.700' : 'gray.300'} fontSize="sm">
              Hub Counter ID: {hubCounter.hubCounterID}
            </Text>
          ) : null}
          <Text color={colorMode === 'light' ? 'gray.700' : 'gray.300'} fontSize="sm">
            Registrierungsdatum: {moment(dropPoint.createdAt).format('DD.MM.YYYY HH:mm')}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
